export default __webpack_public_path__ + "static/tm-6de6696b70775fd30f3b5a237fceb28c.svg";